import { render, staticRenderFns } from "./commonTransfer.vue?vue&type=template&id=376883c8&"
import script from "./commonTransfer.vue?vue&type=script&lang=js&"
export * from "./commonTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports